import React from 'react';
import CreateProblem from './createproblem';
import Layout from './layout';
import "./styles/discussions.css"
export default function Discussion() {
    return (
        <Layout>
            <div className="ds-wrapper">
                discussions
            </div>

        </Layout>
    )
}